import DialogIcon from 'features/Widgets/WidgetsCard/DialogIcon'
import ExcludeIcon from 'features/Widgets/WidgetsCard/ExcludeIcon'
import PromotionIcon from 'features/Widgets/WidgetsCard/PromotionIcon'
import SnippetIcon from 'features/Widgets/WidgetsCard/SnippetIcon'
import PropTypes from 'prop-types'

import styles from './WidgetsCard.module.scss'

const Icon = ({ type }) => {
  switch (type) {
    case 'dialog':
      return <DialogIcon />
    case 'snippet':
      return <SnippetIcon />
    case 'exclude':
      return <ExcludeIcon />
    case 'promotion':
      return <PromotionIcon />
    default:
      return null
  }
}

const WidgetsCard = ({ title, description, type, onClick }) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.cardIcon}>
        <Icon type={type} />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  )
}

WidgetsCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.oneOf(['dialog', 'snippet', 'exclude', 'promotion'])
}

export default WidgetsCard
